import React, { Component } from "react";
import { Button, Input, Select, Table, Modal, TimePicker, message } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import 'moment-duration-format';
import StoreAPI from '@/api/store';
import utils from '@/utils/auth';
const { Search } = Input;
const Container = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: inline-flex;
      align-items: center;
      margin-right: 10px;
      .search-input {
        width: 260px;
      }
    }
  }
`;

const BusinessModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 40px;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .label {
      position: relative;
      white-space: nowrap;
      &::after {
        content: '*';
        position: absolute;
        top: 10%;
        left: -8px;
        color: red;
        vertical-align: middle;
      }
    }
    .value {
      .select-label {
        margin-left: 4px;
      }
    }
  }
`;

const ReservationModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 40px;
  .item {
    display: flex;
    align-items: center;
    height: 40px;
    .label {
      position: relative;
      white-space: nowrap;
      &.required::before {
        content: '*';
        position: absolute;
        top: 10%;
        left: -8px;
        color: red;
        vertical-align: middle;
      }
      &::after {
        content:"";
        width: 100%;
        overflow: hidden;
        height: 0;
      }
    }
    .value {
      width: 300px;
      .select-label {
        margin-left: 4px;
      }
    }
  }
`;

class StoreBusinessSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        keyword: '',
        pageNum: 1,
        pageSize: 10,
      },
      storeList: [],
      total: 0,

      minuteOptions: [
        {
          label: 30,
          value: 30
        },
        {
          label: 60,
          value: 60
        }
      ],
      storeBusinessVisible: false,
      itemInfo: {},
      storeReservationVisible: false,
      businessStartTime: null,
      businessEndTime: null,
      separateTime: null,
    };
  }

  componentDidMount() {
    this.initPage();
  }

  initPage = () => {
    const { searchParams } = this.state;
    StoreAPI.queryStoreBusinessSettingsList(searchParams)
    .then(({ items: storeList, paginator }) => {
      const { totalCount: total } = paginator;
      this.setState({ storeList, total });
  });
  }

  onSearch = () => {
    this.setState({
      searchParams: Object.assign(this.state.searchParams, { pageNum: 1 })
    }, this.initPage);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.initPage);
  }

  showBusinessSettingModal = () => {
    this.setState({ businessStartTime: '', businessEndTime: '', separateTime: null, storeBusinessVisible: true });
  }

  storeBusinessSave = () => {
    const { businessStartTime, businessEndTime, separateTime } = this.state;
    if (!businessStartTime || !businessEndTime) return message.warning('营业时间不能为空');
    if (!separateTime) return message.warning('分隔时间不能为空');
    const params = {
      bindRule: 0,
      businessStartTime: this.getMinutes(businessStartTime),
      businessEndTime: this.getMinutes(businessEndTime),
      separateTime
    };
    StoreAPI.saveStoreBusinessSettings(params)
      .then(res => {
        message.success('保存成功');
        this.setState({ storeBusinessVisible: false }, this.initPage);
      });
  }

  showStoreReservationModal = item => {
    const { businessStartTime, businessEndTime } = item;
    const startTime = businessStartTime < 60 ?
        (`00:${businessStartTime < 10 ? `0${businessStartTime}` : businessStartTime}`)
        : moment.duration(businessStartTime, 'minutes').format("HH:mm");
    const endTime = businessEndTime < 60 ?
        (`00:${businessEndTime < 10 ? `0${businessEndTime}` : businessEndTime}`)
      : moment.duration(businessEndTime, 'minutes').format("HH:mm");

    this.setState({ itemInfo: Object.assign({}, item, { businessStartTime: startTime, businessEndTime: endTime }), storeReservationVisible: true });
  }

  storeReservationSave = () => {
    const { itemInfo } = this.state;
    const { businessStartTime, businessEndTime, separateTime, kdtId: deptId } = itemInfo;
    if (!businessStartTime || !businessEndTime) return message.warning('营业时间不能为空');
    if (!separateTime) return message.warning('分隔时间不能为空');

    const { kdtId } = JSON.parse(localStorage.getItem('userInfo') || '{}');
    let params = {
      // 总部 传当前编辑的店铺id，其他门店编辑 传当前登录者的店铺id
      bindRule: 1,
      kdtId: utils.isUserHeadQuarter() ? deptId : kdtId,
      businessStartTime: this.getMinutes(businessStartTime),
      businessEndTime: this.getMinutes(businessEndTime),
      separateTime
    };

    StoreAPI.saveStoreBusinessSettings(params)
      .then(() => {
        message.success('保存成功');
        this.setState({ storeReservationVisible: false }, this.initPage);
      });
  }

  getMinutes = time => {
    const parts = time.split(':');
    // 使用moment的duration方法创建新的duration对象
    const duration = moment.duration({hours: parts[0], minutes: parts[1]});
    // 将时间转换为分钟
    return duration.asMinutes();
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);

    const { searchParams, storeList, total, storeBusinessVisible, itemInfo, minuteOptions, storeReservationVisible, businessStartTime, businessEndTime, separateTime } = this.state;
    const columns = [
      {
        title: '美团店铺名称',
        dataIndex: 'opPoiName',
        key: 'opPoiName'
      },
      {
        title: '美团店铺ID',
        dataIndex: 'opPoiId',
        key: 'opPoiId'
      },
      {
        title: '营业时间',
        render: ({ businessStartTime, businessEndTime }) => {
          if (businessEndTime > 0) {
            const startTime = businessStartTime === 0 ? '00' : moment.duration(businessStartTime, 'minutes').format("HH:mm");
            const endTime = moment.duration(businessEndTime, 'minutes').format("HH:mm");
            return `${businessStartTime < 60 ? '00:' : ''}${startTime} - ${businessEndTime < 60 ? '00:' : ''}${endTime}`;
          } else {
            return '未设置';
          }
        }
      },
      {
        title: '分隔时长(分钟)',
        dataIndex: 'separateTime',
        key: 'separateTime'
      },
      {
        title: '操作',
        render: item => <Button type="link" disabled={!status} onClick={() => this.showStoreReservationModal(item)}>编辑</Button>
      }
    ];

    return (
        <Container>
          <div className="search-wrapper">
            <div className="search">
              <span className="label">店铺名称：</span>
              <Search
                  allowClear
                  enterButton="搜索"
                  value={searchParams.keyword}
                  placeholder="请输入店铺名称/ID"
                  className="search-input"
                  onSearch={this.onSearch}
                  onChange={e => {
                    const value = e.target.value;
                    this.setState({ searchParams: Object.assign(searchParams, { keyword: value }) });
                  }}
              />
            </div>
            <Button type="primary" disabled={!status} onClick={this.showBusinessSettingModal}>统一设置</Button>
          </div>

          <div className="content-wrapper">
            <Table
                rowKey="kdtId"
                columns={columns}
                dataSource={storeList}
                pagination={{
                  current: searchParams.pageNum,
                  pageSize: searchParams.pageSize,
                  total,
                  showTotal: total => `共${total}条`,
                  hideOnSinglePage: false,
                  onChange: this.onPageChange
                }}
            />
          </div>

          <Modal
              title="门店营业统一设置"
              open={storeBusinessVisible}
              maskClosable={false}
              onOk={this.storeBusinessSave}
              onCancel={() => this.setState({ storeBusinessVisible: false })}
          >
            <BusinessModalWrapper>
              <div className="item">
                <span className="label">门店营业时间：</span>
                <div className="value">
                <TimePicker.RangePicker
                  format="HH:mm"
                  value={[
                    businessStartTime ? moment(businessStartTime, 'HH:mm') : '',
                    businessEndTime ? moment(businessEndTime, 'HH:mm') : ''
                  ]}
                  onChange={(momentArr, [businessStartTime, businessEndTime]) => {
                    this.setState({ businessStartTime, businessEndTime });
                  }}
                />
                </div>
              </div>
              <div className="item">
                <span className="label">分隔时长：</span>
                <div className="value">
                  <Select
                    allowClear
                    showSearch
                    style={{width: 200}}
                    value={separateTime}
                    options={minuteOptions}
                    placeholder="请选择分隔时长"
                    onChange={value => {
                      this.setState({ separateTime: value });
                    }}
                  />
                  <span className="select-label">分钟</span>
                </div>
              </div>
            </BusinessModalWrapper>
          </Modal>

          <Modal
            title="门店营业设置"
            open={storeReservationVisible}
            maskClosable={false}
            onOk={this.storeReservationSave}
            onCancel={() => this.setState({ storeReservationVisible: false })}
          >
            <ReservationModalWrapper>
              <div className="item">
                <div className="label">美团店铺名称：</div>
                <div className="value">{itemInfo.mtShopName}</div>
              </div>
              <div className="item">
                <div className="label">美团店铺ID：</div>
                <div className="value">{itemInfo.mtShopId}</div>
            </div>
            <div className="item">
                <span className="label required">门店营业时间：</span>
                <div className="value">
                <TimePicker.RangePicker
                  format="HH:mm"
                  value={[
                    itemInfo.businessStartTime === null ? '' : moment(itemInfo.businessStartTime, 'HH:mm'),
                    itemInfo.businessEndTime === null ? '' : moment(itemInfo.businessEndTime, 'HH:mm'),
                  ]}
                  onChange={(momentArr, [businessStartTime, businessEndTime]) => {
                    this.setState({ itemInfo: Object.assign({}, itemInfo, { businessStartTime, businessEndTime }) });
                  }}
                />
                </div>
              </div>
              <div className="item">
                <div className="label required">分隔时长：</div>
                <div className="value">
                  <Select
                    allowClear
                    showSearch
                    style={{ width: 200 }}
                    value={itemInfo.separateTime}
                    options={minuteOptions}
                    placeholder="请选择分隔时长"
                    onChange={value => {
                      this.setState({ itemInfo: Object.assign({}, itemInfo, { separateTime: value }) });
                    }}
                  />
                  <span className="select-label">分钟</span>
                </div>
              </div>
            </ReservationModalWrapper>
          </Modal>
        </Container>
    );
  }
}

export default StoreBusinessSetting;
